import * as React from 'react';

import EntityAvatar, { EntityAvatarDefaultProps } from './EntityAvatar';

import { getEntityFromProfile } from 'utils/view';

import type { BrandProfile, Influencer, InfluencerProfile, InfluencerSelector, SubcampaignInfluencerProfile } from 'types';
import type { EntityAvatarProps } from './EntityAvatar';

type Props = EntityAvatarProps & {
  profile: BrandProfile | Influencer | InfluencerProfile | SubcampaignInfluencerProfile | InfluencerSelector,
  disabled?: boolean,
  isAdmin?: boolean
};

function ProfileEntityAvatar({
  profile,
  disabled,
  isAdmin,
  ...props
}: Props) {
  const entity = getEntityFromProfile(profile, isAdmin);

  return (
    <EntityAvatar
      entity={entity}
      link={disabled ? '' : entity?.url}
      {...props}
    />
  );
}

ProfileEntityAvatar.defaultProps = EntityAvatarDefaultProps;

export default ProfileEntityAvatar;
